import type { ViewProps } from 'react-native'
import * as Comp from './bottom-sheets-container.styles'

export const BottomSheetsContainer = ({ children }: ViewProps) => {
  return <Comp.Container>{children}</Comp.Container>
}
